<template>
  <v-container fluid fill-height>
    <v-layout justify-center>
      <v-flex>
        <v-row>
          <v-col cols="12">
            <v-card>
              <v-card-title>
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="البحث"
                  single-line
                  hide-details
                  class="centered-input" 
                ></v-text-field>
              </v-card-title>
              <v-data-table
                :headers="headers"
                :items="Items"
                :search="search"
                items-per-page = 60
                class="elevation-12"
                dense
                hide-default-footer
                item-key="ID"
                height="57vh"
                loading-text="جارٍ التحميل..."
              >
              <template v-slot:item.name="{ item }">
                  <div class="truncate-column">
                   {{ item.name }}
                   </div>
              </template>
                <template v-slot:item.actions="{ item }">
                  <v-container fluid>
                    <v-row dense>
                      <v-col cols="1">
                        <v-btn x-small fab @click="DecrementItem(item)"
                          ><b style="font-size: large;">-</b></v-btn
                        >
                      </v-col>
                      <v-col cols="3"
                        ><v-text-field
                          rounded
                          dense
                          filled
                          v-model="item.qty"
                          label=""
                          @keydown="checkKeyDownAlphaNumeric($event)"
                          type="number"
                          hide-spin-buttons
                          hide-details=""
                          class="centered-input text--darken-3 ml-3"
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="1">
                        <v-btn
                          class="ml-4"
                          x-small
                          fab
                          @click="IncrementItem(item)"
                          ><b style="font-size: large;">+</b></v-btn
                        >
                      </v-col>
                    </v-row>
                  </v-container>
                </template>
                <template v-slot:item.Order="{ item }">
                  <v-btn
                    color="red darken-2"
                    dark
                    rounded
                    small
                    @click="removeItem(item)"
                    ><v-icon>mdi-delete</v-icon> حذف من السلة</v-btn
                  >
                </template>
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>
        <v-snackbar
          transition="fade-transition"
          v-model="snackbar1"
          :timeout="timeout"
        >
          الكمية لا يمكن ان تكون تحت الصفر
        </v-snackbar>
        <v-snackbar
          transition="fade-transition"
          v-model="snackbar2"
          :timeout="timeout"
        >
          الكمية لا يمكن ان تكون تحت الصفر او تساويه
        </v-snackbar>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: "OrdersTable",

  data() {
    return {
      timeout: 1700,
      snackbar: false,
      snackbar0: false,
      snackbar1: false,
      snackbar2: false,
      search: "",
      Items: [],
      headers: [
        { text: "اسم المادة", value: "name" },
        { text: "", value: "actions", align: "start" },
        { text: "", value: "Order" },
      ],
    };
  },

  created() {
    this.GetItems();
  },

  methods: {
    GetItems() {
      this.Items = this.$store.getters.CurrentCart;
      this.Items.forEach((element) => {
        element.qty = element.qty;
        element.name = element.name;
      });
    },
    IncrementItem(item) {
      if (item.qty === "") {
        item.qty = 1;
      } else {
        item.qty = parseInt(item.qty);
        this.Items.forEach((element) => {
          if (item === element) element.qty++;
        });
      }
    },
    DecrementItem(item) {
      if (item.qty == 0) {
        this.snackbar1 = true;
      } else {
        item.qty = parseInt(item.qty);
        this.Items.forEach((element) => {
          if (item === element) element.qty--;
        });
      }
    },
    OnItemCountChange(item) {
      if (item.qty < 0) {
        item.qty = 0;
        this.snackbar1 = true;
      }
    },
    checkKeyDownAlphaNumeric(event) {
      if (event.key === "Backspace") {
      } else if (!/^[0-9]\d*$/.test(event.key)) {
        this.ignoredValue = event.key ? event.key : "";
        event.preventDefault();
      }
    },
    removeItem(item) {
      this.$store.dispatch("removeitem", item);
      this.GetItems()
    },
  },
};
</script>

<style scoped>
.centered-input >>> input {
  text-align: center;
}

.truncate-column {
  max-width: 550px;
}
</style>
